import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { TranslationsKeys } from '../../../../locales/translations';

export function PerformanceAnalysisDetailTablePassed({
  passed,
}: {
  passed: boolean | null;
}) {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );

  const passedStatusText = useMemo(() => {
    return t<
      string,
      {
        PASSED: string;
        FAILED: string;
        PENDING: string;
      }
    >('tableDetail.passedStatus', {
      returnObjects: true,
    });
  }, [t]);

  if (passed === true) {
    return <span className="text-success">{passedStatusText.PASSED}</span>;
  } else if (passed === false) {
    return <span className="text-danger">{passedStatusText.FAILED}</span>;
  }
  return <span>{passedStatusText.PENDING}</span>;
}
